"use strict";

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : new P(function (resolve) {
        resolve(result.value);
      }).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
    label: 0,
    sent: function sent() {
      if (t[0] & 1) throw t[1];
      return t[1];
    },
    trys: [],
    ops: []
  },
      f,
      y,
      t,
      g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;

  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }

  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");

    while (_) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];

        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;

          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };

          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;

          case 7:
            op = _.ops.pop();

            _.trys.pop();

            continue;

          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }

            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }

            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }

            if (t && _.label < t[2]) {
              _.label = t[2];

              _.ops.push(op);

              break;
            }

            if (t[2]) _.ops.pop();

            _.trys.pop();

            continue;
        }

        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }

    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var mobx_1 = require("mobx");

var utils_1 = require("../internal/utils");

var types_1 = require("./types");
/**
 * Just a wrapper around the helpers for a set of FieldStates or FormStates
 */


var FormState =
/** @class */
function () {
  function FormState(
  /**
   * SubItems can be any Validatable
   */
  $) {
    var _this = this;

    this.$ = $;
    this.mode = 'object';
    /** Get validatable objects from $ */

    this.getValues = function () {
      if (_this.mode === 'array') return _this.$;
      if (_this.mode === 'map') return Array.from(_this.$.values());
      var keys = Object.keys(_this.$);
      return keys.map(function (key) {
        return _this.$[key];
      });
    };

    this.validating = false;
    this._validators = [];

    this.validators = function () {
      var validators = [];

      for (var _i = 0; _i < arguments.length; _i++) {
        validators[_i] = arguments[_i];
      }

      _this._validators = validators;
      return _this;
    };

    this._error = '';
    /**
     * Resets all the fields in the form
     */

    this.reset = function () {
      _this.getValues().map(function (v) {
        return v.reset();
      });
    };
    /**
     * Auto validation
     */


    this.autoValidationEnabled = false;

    this.enableAutoValidation = function () {
      _this.autoValidationEnabled = true;

      _this.getValues().forEach(function (x) {
        return x.enableAutoValidation();
      });
    };

    this.enableAutoValidationAndValidate = function () {
      _this.enableAutoValidation();

      return _this.validate();
    };

    this.disableAutoValidation = function () {
      _this.autoValidationEnabled = false;

      _this.getValues().forEach(function (x) {
        return x.disableAutoValidation();
      });
    };
    /**
     * Composible field validation tracking
     */


    this.validatedSubFields = [];

    this._on$ValidationPass = function () {};

    this._on$Reinit = function () {};

    this._setCompositionParent = function (config) {
      _this._on$ValidationPass = function () {
        return mobx_1.runInAction(config.on$ValidationPass);
      };

      _this._on$Reinit = function () {
        return mobx_1.runInAction(config.on$Reinit);
      };
    };

    this.mode = mobx_1.isArrayLike($) ? 'array' : utils_1.isMapLike($) ? 'map' : 'object';
    /** If they didn't send in something observable make the local $ observable */

    if (!mobx_1.isObservable(this.$)) {
      this.$ = mobx_1.observable(this.$);
    }
  }
  /**
   * - Re-runs validation on all fields
   * - returns `hasError`
   * - if no error also return the validated values against each key.
   */


  FormState.prototype.validate = function () {
    return __awaiter(this, void 0, void 0, function () {
      var values, fieldsResult, done, error, res;

      var _this = this;

      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            this.validating = true;
            values = this.getValues();
            return [4
            /*yield*/
            , Promise.all(values.map(function (value) {
              return value.validate();
            }))];

          case 1:
            fieldsResult = _a.sent();
            done = mobx_1.runInAction(function () {
              if (fieldsResult.some(function (f) {
                return f.hasError;
              })) {
                _this.validating = false;
                return true;
              }

              return false;
            });
            if (done) return [2
            /*return*/
            , {
              hasError: true
            }];
            return [4
            /*yield*/
            , types_1.applyValidators(this.$, this._validators || [])];

          case 2:
            error = _a.sent();
            res = mobx_1.runInAction(function () {
              if (error != _this._error) {
                _this._error = error;
              }

              _this.validating = false;
              var hasError = !!error;

              if (hasError) {
                return {
                  hasError: true
                };
              }

              _this._on$ValidationPass();

              return {
                hasError: false,
                value: _this.$
              };
            });
            return [2
            /*return*/
            , res];
        }
      });
    });
  };

  Object.defineProperty(FormState.prototype, "hasError", {
    /**
     * Does any field or form have an error
     */
    get: function get() {
      return this.hasFieldError || this.hasFormError;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(FormState.prototype, "hasFieldError", {
    /**
     * Does any field have an error
     */
    get: function get() {
      return this.getValues().some(function (f) {
        return f.hasError;
      });
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(FormState.prototype, "hasFormError", {
    /**
     * Does form level validation have an error
     */
    get: function get() {
      return !!this._error;
    },
    enumerable: true,
    configurable: true
  });
  /**
   * Call it when you are `reinit`ing child fields
   */

  FormState.prototype.clearFormError = function () {
    this._error = '';
  };

  Object.defineProperty(FormState.prototype, "fieldError", {
    /**
     * Error from some sub field if any
     */
    get: function get() {
      var subItemWithError = this.getValues().find(function (f) {
        return !!f.hasError;
      });
      return subItemWithError ? subItemWithError.error : null;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(FormState.prototype, "formError", {
    /**
     * Error from form if any
     */
    get: function get() {
      return this._error;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(FormState.prototype, "error", {
    /**
     * The first error from any sub (if any) or form error
     */
    get: function get() {
      return this.fieldError || this.formError;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(FormState.prototype, "showFormError", {
    /**
     * You should only show the form error if there are no field errors
     */
    get: function get() {
      return !this.hasFieldError && this.hasFormError;
    },
    enumerable: true,
    configurable: true
  });
  /**
   * Composible fields (fields that work in conjuction with FormState)
   */

  FormState.prototype.compose = function () {
    var _this = this;

    var values = this.getValues();
    values.forEach(function (value) {
      return value._setCompositionParent({
        on$Reinit: mobx_1.action(function () {
          _this.validatedSubFields = _this.validatedSubFields.filter(function (v) {
            return v !== value;
          });
        }),
        on$ValidationPass: mobx_1.action(function () {
          /** Always clear the form error as its no longer relevant */
          if (_this.hasFormError) {
            _this.clearFormError();
          }
          /** Add the field to the validated sub fields */


          if (_this.validatedSubFields.indexOf(value) === -1) {
            _this.validatedSubFields.push(value);
          }
          /**
           * Compose triggers an automatic self validation of the form based on this criteria
           */


          if (
          /** If no field has error */
          !_this.hasFieldError
          /** And there isn't an active validation taking place */
          && !_this.validating
          /** And all subfields are validated */
          && !_this.getValues().some(function (value) {
            return _this.validatedSubFields.indexOf(value) === -1;
          })) {
            _this.validate();
          }
        })
      });
    });
    return this;
  };

  __decorate([mobx_1.observable], FormState.prototype, "validating", void 0);

  __decorate([mobx_1.action], FormState.prototype, "validators", void 0);

  __decorate([mobx_1.action], FormState.prototype, "validate", null);

  __decorate([mobx_1.observable], FormState.prototype, "_error", void 0);

  __decorate([mobx_1.computed], FormState.prototype, "hasError", null);

  __decorate([mobx_1.computed], FormState.prototype, "hasFieldError", null);

  __decorate([mobx_1.computed], FormState.prototype, "hasFormError", null);

  __decorate([mobx_1.action], FormState.prototype, "clearFormError", null);

  __decorate([mobx_1.computed], FormState.prototype, "fieldError", null);

  __decorate([mobx_1.computed], FormState.prototype, "formError", null);

  __decorate([mobx_1.computed], FormState.prototype, "error", null);

  __decorate([mobx_1.computed], FormState.prototype, "showFormError", null);

  __decorate([mobx_1.action], FormState.prototype, "reset", void 0);

  __decorate([mobx_1.observable], FormState.prototype, "autoValidationEnabled", void 0);

  __decorate([mobx_1.action], FormState.prototype, "enableAutoValidation", void 0);

  __decorate([mobx_1.action], FormState.prototype, "enableAutoValidationAndValidate", void 0);

  __decorate([mobx_1.action], FormState.prototype, "disableAutoValidation", void 0);

  __decorate([mobx_1.observable], FormState.prototype, "validatedSubFields", void 0);

  __decorate([mobx_1.action], FormState.prototype, "compose", null);

  __decorate([mobx_1.action], FormState.prototype, "_setCompositionParent", void 0);

  return FormState;
}();

exports.FormState = FormState;